import { Button } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogTitle,
	DialogTrigger,
} from '@/components/ui/dialog';
import { components } from '@/types/strapi';
import { PopupContent } from './PopupContent';

interface PopupProps {
	popup: components['schemas']['SharedPopupComponent'];
	buttonText: string;
	buttonVariant?: components['schemas']['SharedButtonComponent']['variant'];
	isOpen: boolean;
	setIsOpen: (open: boolean) => void;
}

export const Popup = ({
	popup,
	buttonText,
	buttonVariant = 'default',
	isOpen,
	setIsOpen,
}: PopupProps) => {
	if (!popup) return null;
	const maxw =
		popup.internalContent?.layout == 'two-column' ? 'max-w-[75vw]' : '';
	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogTrigger asChild>
				<Button size="lg" variant={buttonVariant}>
					{buttonText}
				</Button>
			</DialogTrigger>
			<DialogContent
				className={`mx-auto my-5 max-h-[85vh] ${maxw} overflow-y-auto rounded-lg bg-white p-5 shadow-lg md:min-w-[400px]`}>
				<DialogTitle className="sr-only">Popup</DialogTitle>
				<PopupContent popup={popup} />
			</DialogContent>
		</Dialog>
	);
};
